export const createTimeUnitFunction = `
function(type, value, label, liveEl) {
const wrapper = document.createElement('span');
wrapper.className = 'countdown-unit countdown-' + type;

const valueEl = document.createElement('span');
valueEl.className = 'countdown-value';
valueEl.textContent = value.toString();

const labelEl = document.createElement('span');
labelEl.className = 'countdown-label';
labelEl.textContent = ' ' + label;

wrapper.appendChild(valueEl);
wrapper.appendChild(labelEl);
liveEl.appendChild(wrapper);
return wrapper;
}
`;

export const addSeparatorFunction = `
function(liveEl, separator) {
const separatorEl = document.createElement('span');
separatorEl.className = 'countdown-separator';
separatorEl.textContent = separator;
liveEl.appendChild(separatorEl);
}
`;

export const calculateTimeUnitsFunction = `
function(diff) {
return {
  days: Math.floor(diff / (1000 * 60 * 60 * 24)),
  hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
  minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
  seconds: Math.floor((diff % (1000 * 60)) / 1000)
};
}
`;

export const registerFunction = `
function(countdownId, options) {
this.countdowns[countdownId] = {
...options,
initialized: false
};
// Initialize countdowns if we haven't already set up listeners
if (!this.initialized) {
this.setupGlobalListeners();
}
// Initialize this countdown
this.initializeCountdown(countdownId);
}
`;

export const clearIntervalFunction = `
function(countdownId) {
if (this.intervals[countdownId]) {
clearInterval(this.intervals[countdownId]);
delete this.intervals[countdownId];
}
}
`;

export const clearAllIntervalsFunction = `
function() {
Object.keys(this.intervals).forEach(countdownId => {
clearInterval(this.intervals[countdownId]);
});
this.intervals = {};
}
`;

export const initializeAllCountdownsFunction = `
function() {
Object.keys(this.countdowns).forEach(countdownId => {
this.countdowns[countdownId].initialized = false;
this.initializeCountdown(countdownId);
});
}
`;

export const resetAllCountdownsFunction = `
function() {
this.clearAllIntervals();
Object.keys(this.countdowns).forEach(countdownId => {
this.countdowns[countdownId].initialized = false;
});
// Re-initialize with a delay to ensure DOM is ready
setTimeout(() => this.initializeAllCountdowns(), 50);
}
`;

export const setupGlobalListenersFunction = `
function() {
if (this.initialized) return;
this.initialized = true;

// Initialize on DOM ready
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => this.initializeAllCountdowns(), 100);
});
} else {
setTimeout(() => this.initializeAllCountdowns(), 100);
}

// Handle Next.js navigation using multiple detection methods
// This is critical for soft navigation support
if (typeof window !== 'undefined') {
// Method 1: Listen for route change events
if (window.__NEXT_DATA__) {
  document.addEventListener('routeChangeComplete', () => {
    this.resetAllCountdowns();
  });
}

// Method 2: Check for Next.js router object directly
const checkNextRouter = () => {
  if (window.next && window.next.router) {
    window.next.router.events.on('routeChangeComplete', () => {
      this.resetAllCountdowns();
    });
  } else {
    // Try again later
    setTimeout(checkNextRouter, 1000);
  }
};

checkNextRouter();

window.addEventListener('beforeunload', () => {
  this.clearAllIntervals();
});
}
}
`;

export const initializeCountdownFunction = `
function(countdownId) {
const data = this.countdowns[countdownId];
if (!data || data.initialized) return;
const element = document.getElementById(countdownId);
if (!element) {
delete this.countdowns[countdownId];
return;
}

data.initialized = true;
this.clearInterval(countdownId);

const updateCounter = () => {
try {
  // Get data from element's data attributes
  const finishDate = element.getAttribute('data-finish-date');
  const locale = element.getAttribute('data-locale') || 'en-GB';
  const timezone = element.getAttribute('data-timezone') || 'Europe/London';;
  const textDays = element.getAttribute('data-text-days');
  const textDay = element.getAttribute('data-text-day');
  const textHours = element.getAttribute('data-text-hours');
  const textHour = element.getAttribute('data-text-hour');
  const textMinutes = element.getAttribute('data-text-minutes');
  const textMinute = element.getAttribute('data-text-minute');
  const textSeconds = element.getAttribute('data-text-seconds');
  const textSecond = element.getAttribute('data-text-second');

  const separator = element.getAttribute('data-separator');
  const showDays = element.getAttribute('data-show-days') === 'true';
  const showHours = element.getAttribute('data-show-hours') === 'true';
  const showMinutes = element.getAttribute('data-show-minutes') === 'true';
  const showSeconds = element.getAttribute('data-show-seconds') === 'true';
  
  const targetDate = new Date(finishDate);
  const now = new Date();
  let diff = targetDate - now;

  const calculateTimezoneDifference = () => {
    const timezoneFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    });
    
    const timezoneParts = timezoneFormatter.formatToParts(now);
    const getValue = (parts, type) => {
      const part = parts.find(p => p.type === type);
      return part ? parseInt(part.value, 10) : 0;
    };
  
    const timezoneNow = new Date(
      getValue(timezoneParts, 'year'),
      getValue(timezoneParts, 'month') - 1,
      getValue(timezoneParts, 'day'),
      getValue(timezoneParts, 'hour'),
      getValue(timezoneParts, 'minute'),
      getValue(timezoneParts, 'second')
    );
    
    const timezoneTarget = new Date(
      targetDate.getFullYear(),
      targetDate.getMonth(),
      targetDate.getDate(),
      targetDate.getHours(),
      targetDate.getMinutes(),
      targetDate.getSeconds()
    );
    
    return timezoneTarget - timezoneNow;
  };

  try {
    diff = calculateTimezoneDifference();
  } catch (error) {
    console.error('Timezone error: ', error);
    diff = targetDate - now;
  }

  // Hide if countdown finished
  if (diff <= 0) {
    const hideParent = element.getAttribute('data-hide-parent') === 'true';
    const parentContentId = element.getAttribute('data-parent-content-id');

    if (hideParent && parentContentId) {
      // Find parent by ID and hide it
      const parentElement = document.getElementById(parentContentId);
      if (parentElement) {
        parentElement.style.display = 'none';
        parentElement.setAttribute('aria-hidden', 'true');
      } else {
        element.style.display = 'none';
        element.setAttribute('aria-hidden', 'true');
      }
    } else {
      // Just hide the countdown element
      element.style.display = 'none';
      element.setAttribute('aria-hidden', 'true');
    }

    this.clearInterval(countdownId);
    return;
  }

  const { days, hours, minutes, seconds } = this.calculateTimeUnits(diff);
  
  // This implements the "show only relevant intervals" requirement
  let countdownText = '';
  let ariaText = '';
  
  // Only show days if enabled and we have days remaining
  if (showDays && days > 0) {
    const daysText = days + ' ' + (days === 1 ? textDay : textDays);
    countdownText += daysText;
    ariaText += daysText;
  }
  
  // Only show hours if enabled
  if (showHours) {
    // Calculate total hours
    let totalHours = hours;

    if (!showDays && days > 0) {
      totalHours = (days * 24) + hours; // Convert days to hours and add
    }

    // Only show if we have hours or if we have no other units to show
    if (totalHours > 0 || (countdownText === '' && days === 0)) {
      const hoursText = totalHours + ' ' + (totalHours === 1 ? textHour : textHours);
      countdownText += (countdownText ? separator : '') + hoursText;
      ariaText += (ariaText ? ' ' : '') + hoursText;
    }
  }
  
  // Only show minutes if enabled and either:
  // 1. We have minutes remaining, or
  // 2. We're not showing days/hours and have no days/hours remaining
  if (showMinutes && (minutes > 0 || (countdownText === '' && days === 0 && hours === 0))) {
    const minutesText = minutes + ' ' + (minutes === 1 ? textMinute : textMinutes);
    countdownText += (countdownText ? separator : '') + minutesText;
    ariaText += (ariaText ? ' ' : '') + minutesText;
  }
  
  // Only show seconds if enabled
  if (showSeconds) {
    const secondsText = seconds + ' ' + (seconds === 1 ? textSecond : textSeconds);
    countdownText += (countdownText ? separator : '') + secondsText;
    ariaText += (ariaText ? ' ' : '') + secondsText;
  }
  
  // Remove the placeholder (if it exists) and update the content
  const placeholderEl = element.querySelector('.countdown-static');
  if (placeholderEl) {
    placeholderEl.parentNode.removeChild(placeholderEl);
  }
  
  // Create or update the live element
  let liveEl = element.querySelector('.countdown-live');
  if (!liveEl) {
    liveEl = document.createElement('span');
    liveEl.className = 'countdown-live';
    element.appendChild(liveEl);
  }

  liveEl.innerHTML = '';

  if (showDays && days > 0) {
    this.createTimeUnit('days', days, (days === 1 ? textDay : textDays), liveEl);
    
    // Add separator if not the last unit
    if (showHours || showMinutes || showSeconds) {
      this.addSeparator(liveEl, separator);
    }
  }

  if (showHours) {
    // Calculate total hours
    let totalHours = hours;

    if (!showDays && days > 0) {
      totalHours = (days * 24) + hours; // Convert days to hours and add
    }

    // Only show if we have hours or if we have no other units to show
    if (totalHours > 0 || (days === 0 && !showMinutes && !showSeconds)) {
      this.createTimeUnit('hours', totalHours, (totalHours === 1 ? textHour : textHours), liveEl);
      
      // Add separator if not the last unit
      if (showMinutes || showSeconds) {
        this.addSeparator(liveEl, separator);
      }
    }
  }

  if (showMinutes && (minutes > 0 || (days === 0 && hours === 0 && !showSeconds))) {
    this.createTimeUnit('minutes', minutes, (minutes === 1 ? textMinute : textMinutes), liveEl);
    
    // Add separator if seconds are shown
    if (showSeconds) {
      this.addSeparator(liveEl, separator);
    }
  }

  if (showSeconds) {
    this.createTimeUnit('seconds', seconds, (seconds === 1 ? textSecond : textSeconds), liveEl);
  }

  // Update the aria-label for screen readers
  element.setAttribute('aria-label', 'Time remaining: ' + ariaText);
} catch (error) {
  console.error('Error updating countdown:', error);
  element.textContent = 'Countdown unavailable';
}
};

updateCounter();

// Set interval frequency based on whether seconds are shown
// This optimizes performance by updating less frequently when seconds aren't displayed
const intervalMs = data.showSeconds ? 1000 : 60000;
this.intervals[countdownId] = setInterval(updateCounter, intervalMs);
}
`;
